import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M5 4v6.025V10v10zm2 10h3.5a5.7 5.7 0 0 1 1.3-2H7zm0 4h3.175a5.7 5.7 0 0 1-.15-2H7zm-2 4q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 20V4q0-.824.587-1.413A1.93 1.93 0 0 1 5 2h8l6 6v2.5a6 6 0 0 0-.975-.313A8 8 0 0 0 17 10.025V9h-5V4H5v16h6.025q.4.6.9 1.113a6 6 0 0 0 1.1.887zm11.5-3q1.05 0 1.775-.725T19 16.5c0-1.05-.242-1.292-.725-1.775Q17.55 14 16.5 14c-1.05 0-1.292.242-1.775.725Q14 15.45 14 16.5c0 1.05.242 1.292.725 1.775Q15.45 19 16.5 19m5.1 4-2.7-2.7a4 4 0 0 1-1.137.525A4.6 4.6 0 0 1 16.5 21q-1.875 0-3.188-1.313Q12 18.376 12 16.5t1.313-3.188Q14.625 12 16.5 12t3.188 1.313Q21 14.625 21 16.5q0 .65-.175 1.262A4 4 0 0 1 20.3 18.9l2.7 2.7z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }